import { showApiError, showSuccess } from "@/lib/toast";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addScreenSize } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useSelector } from "react-redux";
import { FormSchemaType, ScreenSizeMetaForm } from "./form/ScreenSizeMetaForm";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { ROUTES } from "@/constants/routeConstants";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import { BaseFormLayout } from "../shared/BaseFormLayout";

export const AddNewScreenSizePage = () => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);

  useBreadcrumbs([
    {
      name: t("entities.screenSize"),
      path: ROUTES.SCREEN_SIZE,
    },
    {
      name: t("common.addNewEntity", { entity: t("entities.screenSize") }),
      path: ROUTES.SCREEN_SIZE_ADD,
    },
  ]);

  const { goToScreenSizeDetail } = useAppNavigate();
  const queryClient = useQueryClient();
  const addScreenSizeMutation = useMutation({
    mutationFn: (values: FormSchemaType) =>
      addScreenSize({
        name: values.name,
        width: Number(values.width),
        height: Number(values.height),
        firmGuid: String(activeFirm?.firmGuid),
      }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ["getScreenSize"],
      });
      showSuccess(t("common.addedSuccess"));
      goToScreenSizeDetail(data.data.newDataId);
    },
    onError: showApiError,
  });

  return (
    <BaseFormLayout title={t("common.addNewEntity", { entity: t("entities.screenSize") })}>
      <ScreenSizeMetaForm
        buttonText={t("common.add")}
        onSubmit={(values) => addScreenSizeMutation.mutate(values)}
        isLoading={addScreenSizeMutation.isPending}
      />
    </BaseFormLayout>
  );
};
